import { SignedData } from "./signed-data";

export class FileData {
  url?: string;
  refDocumentale?: string;
  nomeFile?: string;
  contentType?: string;
  contentSize?: number;
  content?: string;
  versione?: number;
  creatore?: string;
  temporaneo?: boolean;
  signedData?: SignedData;
  algoritmoImprontaDocumento?:string;
  improntaDocumento?:string;
}

